(function (angular) {
	'use strict';

	var investmentGoalDashboardChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			data: '<',
			goalAmount: '<',
			hasEverOwnedIpo: '<',
			onTrackToGoal: '<',
			percentToGoal: '<',
			showGoalSeries: '<',
			startValueOnTrack: '<'
		},
		controller: [
			'$filter',
			'$scope',
			'$timeout',
			'investmentGoalFactory',
			'Highcharts',
			'HIGHCHARTS_OPTIONS',
			investmentGoalDashboardFunction
		],
		controllerAs: 'investmentGoalDashboard'
	};

	angular
		.module('investmentGoalChartModule')
		.component('investmentGoalDashboardChart', investmentGoalDashboardChartObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/charts/investment-goal/investment-goal-dashboard-chart.html';
	}
	
	function investmentGoalDashboardFunction(
		$filter,
		$scope,
		$timeout,
		investmentGoalFactory,
		Highcharts,
		HIGHCHARTS_OPTIONS) {
		
		var investmentGoalDashboard = this;
		var expectedGoalAchievedData;
		var indexWhereGoalDateAchieved;
		var onTrackSeriesColors = {
			arearange: '#99ccff',
			line: '#ffffff'
		};
		var offTrackSeriesColors = {
			arearange: '#F6A01A',
			line: '#F6A01A'
		};

		var highchartsObject = {
			chart: {
				spacing: [ 0, 0, 0, 0 ]
			},
			series: [{
				id: 'projectedEarnings',
				name: 'Projected Account Value',
				type: 'line',
				dashStyle: 'Dash',
				marker: {
					enabled: false,
					symbol: 'circle'
				},
				states: {
					hover: {
						enabled: true
					}
				},
				zIndex: 3
			}, {
				type: 'arearange',
				color: 'transparent',
				enableMouseTracking: false,
				fillColor: {
					linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 }
				},
				variation: 0.5,
				zIndex: 1
			}, {
				type: 'arearange',
				color: 'transparent',
				enableMouseTracking: false,
				fillColor: {
					linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 }
				},
				variation: 0.5,
				zIndex: 1
			}, {
				type: 'arearange',
				color: 'transparent',
				enableMouseTracking: false,
				fillColor: {
					linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 }
				},
				variation: 0.5,
				zIndex: 1
			}, {
				id: 'goal',
				name: 'Goal',
				type: 'line',
				color: '#FFFFFF',
				marker: {
					enabled: false,
					fillColor: '#FFFFFF',
					symbol: 'circle'
				},
				states: {
					hover: {
						enabled: true
					}
				},
				zIndex: 2
			}],
			tooltip: {
				backgroundColor: '#ffffff',
				borderWidth: 0,
				enabled: true,
				formatter: function() {
					var isFirstPoint  = this.point.index === 0;
					var isLastPoint = this.point.index === this.series.data.length - 1;
					if(this.series.name === 'Projected Account Value' && isLastPoint) {
						return '<span class="display-block eta text-align-center">Projected account value</span><span class="display-block delta font-weight-bold heading-text-color text-align-center">' + $filter('currency')(this.point.y, '$', 0) + '</span>';
					} else if(this.series.name  === 'Projected Account Value' && isFirstPoint) {
						var conditionalContent = investmentGoalDashboard.hasEverOwnedIpo ? ",<br>excluding iPO." : "";
						return '<span class="display-block eta text-align-center">Current account value' + conditionalContent + '</span><span class="display-block delta font-weight-bold heading-text-color text-align-center">' + $filter('currency')(this.point.y, '$', 0) + '</span>';
					} else if(this.series.name === 'Goal' && isLastPoint && !investmentGoalDashboard.showGoalSeries) {
						return '<span class="display-block eta text-align-center">Goal account value</span><span class="display-block delta font-weight-bold heading-text-color text-align-center">' + $filter('currency')(investmentGoalDashboard.goalAmount, '$', 0) + '</span>';
					} else {
						return false;
					}
				},
				snap: 50,
				useHTML: true
			},
			xAxis: {
				type: 'datetime'
			},
			yAxis: {
				endOnTick: false,
				labels: {
					formatter: function() {
						return '$' + Highcharts.numberFormat(this.value, 0);
					}
				},
				startOnTick: true,
				tickPixelInterval: 48,
				min: 0
			},
			plotOptions: {
				line: {
					marker: {
						lineWidth: 0,
						states: {
							hover: {
								lineWidth: 0
							}
						}
					}
				}
			},
			responsive: {
				rules: [{
					condition: {
						minWidth: 400
					},
					chartOptions: {
						tooltip: {
							positioner: function(labelWidth, labelHeight, point) {
								var coords = {
									x: this.chart.plotLeft + point.plotX - (labelWidth / 2),
									y: this.chart.plotTop + point.plotY - labelHeight - 16
								};
								return coords;
							}
						}
					}
				}]
			}
		};
		
		investmentGoalDashboard.$onChanges = function(changeObj) {

			var rawData = changeObj.data.currentValue;
			if(angular.isDefined(rawData)) {
				buildChartObject(rawData);
			}
		};

		function getProjectedSeriesColors(onTrackToGoal) {
			if(onTrackToGoal) {
				return onTrackSeriesColors;
			} else {
				return offTrackSeriesColors;
			}
		}

		function buildChartObject(rawData) {

			expectedGoalAchievedData = $filter('filter')(rawData, { expectedGoalAchievedDate: true })[0];
			indexWhereGoalDateAchieved = rawData.indexOf(expectedGoalAchievedData);

			var baseHighchartsOptions = HIGHCHARTS_OPTIONS('dark');
			var projectedSeriesColors = getProjectedSeriesColors(investmentGoalDashboard.onTrackToGoal);

			var areaRangeColorStops = [
				[0, Highcharts.Color(projectedSeriesColors.arearange).setOpacity(0.3).get('rgba')],
				[1, Highcharts.Color(projectedSeriesColors.arearange).setOpacity(0.15).get('rgba')]
			];

			highchartsObject = angular.merge(baseHighchartsOptions, highchartsObject);

			highchartsObject = setLineSeriesData('currentAmount', highchartsObject, 0, indexWhereGoalDateAchieved);

			highchartsObject = setRangeSeriesData('currentAmount', highchartsObject);

			highchartsObject.series[0].color = projectedSeriesColors.line;
			highchartsObject.series[1].fillColor.stops = areaRangeColorStops;
			highchartsObject.series[2].fillColor.stops = areaRangeColorStops;
			highchartsObject.series[3].fillColor.stops = areaRangeColorStops;

			if (investmentGoalDashboard.showGoalSeries) {
				setLineSeriesData('goalAmount', highchartsObject, 4, indexWhereGoalDateAchieved);

				$scope.$on('highchart.load', function(event, renderedChartObject) {
					setComparisonStyles(renderedChartObject);
				});

				$scope.$on('highchart.render', function(event, renderedChartObject) {
					setComparisonStyles(renderedChartObject);
				});
			}

			investmentGoalDashboard.chartOptions = highchartsObject;
		}
		
		function setRangeSeriesData(variationKey, highchartsObject){
			var seriesData = investmentGoalFactory.getRangeChartSeries(investmentGoalDashboard.data, 'date', variationKey);
			
			highchartsObject.series[1].data = seriesData.series1;
			highchartsObject.series[2].data = seriesData.series2;
			highchartsObject.series[3].data = seriesData.series3;

			return highchartsObject;
		}
		
		function setLineSeriesData(variationKey, highchartsObject, seriesIndex, indexWhereGoalDateAchieved){
			var seriesData = investmentGoalFactory.getStandardChartSeries(investmentGoalDashboard.data, 'date', variationKey);
			
			if (variationKey === 'currentAmount') {
				seriesData[0].marker = {
					enabled: true
				};
			}
			
			seriesData[indexWhereGoalDateAchieved].marker = {
				enabled: true
			};
			
			highchartsObject.series[seriesIndex].data = seriesData;

			return highchartsObject;
		}
		
		function setComparisonStyles(renderedChartObject) {
			var goalSeriesOffsetTop = renderedChartObject.series[4].data[indexWhereGoalDateAchieved].plotY;
			var projectedSeriesOffsetTop = renderedChartObject.series[0].data[indexWhereGoalDateAchieved].plotY;
			var top = investmentGoalDashboard.percentToGoal > 100 ? projectedSeriesOffsetTop : goalSeriesOffsetTop;
			var height = investmentGoalDashboard.percentToGoal > 100 ? goalSeriesOffsetTop - projectedSeriesOffsetTop : projectedSeriesOffsetTop - goalSeriesOffsetTop;

			$timeout(function() {
				investmentGoalDashboard.comparisonStyle = {
					height: height + 'px',
					top: top + 'px'
				};
			});
		}
	}
})(window.angular);